var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerSoftwareDev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1084 4H29.9917C26.7432 4 24.1001 6.64307 24.1001 9.8916V27.9282L18.8794 25.332C18.7031 25.2441 18.5239 25.1611 18.3433 25.0825C19.876 23.4824 20.8208 21.3145 20.8208 18.9292C20.8208 14.0195 16.8267 10.0249 11.917 10.0249C7.00684 10.0249 3.0127 14.0195 3.0127 18.9292C3.0127 21.5972 4.19385 23.9937 6.05908 25.627C2.62402 27.5596 0 31.3296 0 36V42.0249C0 44.6187 1.68408 46.8262 4.0166 47.6108V58.0918C4.0166 59.127 4.85596 59.9668 5.8916 59.9668H17.9414C18.9771 59.9668 19.8164 59.127 19.8164 58.0918V37.0249L25.8193 40.0259C28.1167 41.1743 31.2329 40.4897 32.6421 37.875H39.3647L32.2461 57.4507C31.8921 58.4238 32.3945 59.5 33.3677 59.8535C34.48 60.2583 35.4692 59.5605 35.7705 58.7324L43.355 37.875H44.6694L52.3315 58.7383C52.6226 59.5298 53.6045 60.2681 54.7383 59.8516C55.71 59.4946 56.209 58.4175 55.8516 57.4453L48.6641 37.875H58.1084C61.2939 37.875 64 35.3052 64 31.9834V9.8916C64 6.56934 61.2939 4 58.1084 4ZM6.7627 18.9292C6.7627 16.0869 9.07471 13.7749 11.9165 13.7749C14.7588 13.7749 17.0708 16.0869 17.0708 18.9292C17.0708 21.771 14.7588 24.083 11.9165 24.083C9.07471 24.083 6.7627 21.771 6.7627 18.9292ZM29.4375 35.8701C29.4326 35.8838 29.4277 35.8979 29.4233 35.9121C29.2954 36.269 29.0063 36.5698 28.6523 36.7153C28.2778 36.8677 27.8564 36.8516 27.4966 36.6719C23.9312 34.8882 18.7793 32.3145 18.7793 32.3145C17.5352 31.6924 16.0664 32.5986 16.0664 33.9917V56.2168H7.7666V46.0415C7.7666 45.0063 6.92676 44.1665 5.8916 44.1665C4.71045 44.1665 3.75 43.2061 3.75 42.0249V36C3.75 31.4185 7.48047 27.8335 11.9165 27.8335H13.5732C14.8301 27.8335 16.0854 28.1284 17.207 28.6885C17.207 28.6885 26.5073 33.3135 28.876 34.4932C29.3833 34.7451 29.6245 35.3369 29.4375 35.8701ZM60.25 31.9834C60.25 32.5562 60.0278 33.0938 59.6235 33.498C59.2256 33.8965 58.6733 34.125 58.1084 34.125H33.0498C33.0464 34.1147 33.0439 34.1045 33.0405 34.0947L37.6938 24.7886C38.1567 23.8623 37.7817 22.7363 36.8555 22.2729C35.9297 21.8101 34.8032 22.1851 34.3398 23.1113L30.3711 31.0483C29.6313 30.6797 28.7715 30.2515 27.8501 29.7935V9.8916C27.8501 8.71094 28.8105 7.75 29.9917 7.75H58.1084C58.6733 7.75 59.2256 7.97852 59.624 8.37793C60.0278 8.78125 60.25 9.31885 60.25 9.8916V31.9834Z",
    fill: "url(#paint0_linear_35_13)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0918 12.0332H34.0083C32.9727 12.0332 32.1333 12.8726 32.1333 13.9082C32.1333 14.9438 32.9727 15.7832 34.0083 15.7832H54.0918C55.127 15.7832 55.9668 14.9438 55.9668 13.9082C55.9668 12.8726 55.1274 12.0332 54.0918 12.0332Z",
    fill: "url(#paint1_linear_35_13)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0918 19.0625H44.0498C43.0146 19.0625 42.1748 19.9019 42.1748 20.9375C42.1748 21.9731 43.0146 22.8125 44.0498 22.8125H54.0918C55.127 22.8125 55.9668 21.9731 55.9668 20.9375C55.9668 19.9019 55.1274 19.0625 54.0918 19.0625Z",
    fill: "url(#paint2_linear_35_13)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0918 26.0918H44.0498C43.0146 26.0918 42.1748 26.9312 42.1748 27.9668C42.1748 29.002 43.0146 29.8418 44.0498 29.8418H54.0918C55.127 29.8418 55.9668 29.002 55.9668 27.9668C55.9668 26.9312 55.1274 26.0918 54.0918 26.0918Z",
    fill: "url(#paint3_linear_35_13)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_13",
    x1: 32,
    y1: 4,
    x2: 32,
    y2: 59.9719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_13",
    x1: 44.05,
    y1: 12.0332,
    x2: 44.05,
    y2: 15.7832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35_13",
    x1: 49.0708,
    y1: 19.0625,
    x2: 49.0708,
    y2: 22.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35_13",
    x1: 49.0708,
    y1: 26.0918,
    x2: 49.0708,
    y2: 29.8418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSoftwareDev);
export default __webpack_public_path__ + "static/media/customerSoftwareDev.f914c9f9a4da76db61eb7ac88343df6b.svg";
export { ForwardRef as ReactComponent };